import { Inbox } from "lucide-react";
import { type ReactNode } from "react";

import { Button } from "@/components/ui/Button";

import { type TActionDef } from "./types";

type TDataGridEmptyStateProps = {
  icon?: ReactNode;
  title?: string;
  description?: string;
  action?: TActionDef;
  secondaryAction?: TActionDef;
  /** True when the empty result is due to active filters/search. */
  filtered?: boolean;
};

/** Illustration + title + description + primary/secondary action. */
export function DataGridEmptyState({
  icon,
  title,
  description,
  action,
  secondaryAction,
  filtered,
}: TDataGridEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <div className="text-muted-foreground/40">{icon ?? <Inbox className="h-10 w-10" />}</div>
      <div className="space-y-1">
        <p className="text-sm font-semibold text-foreground">{title ?? "No results"}</p>
        <p className="max-w-sm text-sm text-muted-foreground">
          {description ?? (filtered === true ? "Try adjusting your search or filters." : "There's nothing here yet.")}
        </p>
      </div>
      {(action ?? secondaryAction) && (
        <div className="mt-2 flex flex-wrap justify-center gap-2">
          {action && (
            <Button
              size="sm"
              variant={action.variant ?? "default"}
              onClick={action.onClick}
            >
              {action.icon}
              {action.label}
            </Button>
          )}
          {secondaryAction && (
            <Button
              size="sm"
              variant={secondaryAction.variant ?? "outline"}
              onClick={secondaryAction.onClick}
            >
              {secondaryAction.icon}
              {secondaryAction.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
